/** Shared readout formatting for the studio admin dashboard. */

/** Watch time at the precision that reads honestly at each magnitude. */
export function fmtHours(hours: number): string {
  if (hours <= 0) return "0 min";
  if (hours < 1) {
    const minutes = Math.round(hours * 60);
    return minutes > 0 ? `${minutes} min` : "<1 min";
  }
  if (hours >= 100) return `${Math.round(hours)} h`;
  return `${hours.toFixed(1)} h`;
}

export function fmtFamilies(count: number): string {
  return `${count} ${count === 1 ? "family" : "families"}`;
}

export function fmtPlays(count: number): string {
  return `${count} ${count === 1 ? "play" : "plays"}`;
}

/**
 * Clock time for the live card. A dashboard left open does not tick, so
 * "12 min ago" ages into a lie while "9:42 PM" stays true. Older watches keep
 * a date so a bare time can never read as today.
 */
export function fmtWatchClock(iso: string): string {
  const at = new Date(iso);
  const time = at.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  const today = new Date();
  if (at.toDateString() === today.toDateString()) return time;
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (at.toDateString() === yesterday.toDateString()) return `Yesterday ${time}`;
  return `${at.toLocaleDateString("en-US", { month: "short", day: "numeric" })}, ${time}`;
}
